module.exports = __webpack_public_path__ + "static/img/pay-f.caae344.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/pay-f.png
// module id = hp1v
// module chunks = 1